<template>
  <el-dialog width="600px" title="批量修改订单金额" v-model="isvisible">
    <el-form
      ref="orderFormRef"
      :model="orderForm"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="销售金额" prop="saleamount">
        <el-input v-model="orderForm.saleamount" placeholder="请输入销售金额" />
      </el-form-item>
      <el-form-item label="成本金额" prop="costamount">
        <el-input v-model="orderForm.costamount" placeholder="请输入成本金额" />
      </el-form-item>
      <el-form-item label="运费金额" prop="freightamount">
        <el-input v-model="orderForm.freightamount" placeholder="请输入运费金额" />
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
        <el-button type="danger" @click="doBatchSaveOrderAccount" :loading="loading" >{{
          loading ? "提交中 ..." : "确认"
        }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>
  <script setup>
import { ref, defineExpose, defineEmits } from "vue";
import { ElMessage } from "element-plus";
import { batchSaveOrderAccount } from "@/api/order";

let timer;

const loading = ref(false);

const emit = defineEmits(["click"]); // 声明父触发事件


const isvisible = ref(false);
const changeVisible = (v) => {
  isvisible.value = v;
};

const orderFormRef = ref();
const orderForm = ref({
  orderid: "",
  saleamount: "",
  costamount: "",
  freightamount: "",
  maolivstatus: "",
});

const maolivs = ref();
const maolivges = ref();

const saleamounts = ref()
const costamounts = ref()
const freightamounts = ref()

const orderAccountMethod = (obj) => {
  orderForm.value = {
    orderid: obj.orderid,
  };
  maolivs.value = obj.maoliv
  maolivges.value = obj.maolivge
  saleamounts.value = obj.saleamount
  costamounts.value = obj.costamount
  freightamounts.value = obj.freightamount
  // console.log(obj)
};

defineExpose({ changeVisible, orderAccountMethod });

const doBatchSaveOrderAccount = () => {
  orderFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }
    
    //let maoliv = orderForm.value.saleamount / orderForm.value.costamount;

    let maolivArr = maolivs.value
    let maolivgeArr = maolivges.value

    let saleamountArr = saleamounts.value
    let costamountArr = costamounts.value
    let freightamountArr = freightamounts.value

    let orders = [];
    let orderids= orderForm.value.orderid

    for (let i=0;i<maolivArr.length;i++) {
      let tmpSaleamount = orderForm.value.saleamount ? orderForm.value.saleamount : saleamountArr[i]
      let tmpCostamount = orderForm.value.costamount ? orderForm.value.costamount : costamountArr[i]
      let tmpFreightamount = orderForm.value.freightamount ? orderForm.value.freightamount : freightamountArr[i]
      //let maoliv = tmpSaleamount / tmpCostamount;
      let maoliv = (tmpSaleamount - tmpCostamount) / tmpSaleamount;

      if (maoliv >= maolivArr[i] && maoliv <= maolivgeArr[i]) {
        orders.push(
          {
              orderid: orderids[i],
              saleamount: tmpSaleamount,
              costamount: tmpCostamount,
              freightamount: tmpFreightamount,
              maolieamount: tmpSaleamount - tmpCostamount,
              maoliv,
              maolivstatus:1
          }
        )
      } else {
        
        orders.push(
          {
              orderid: orderids[i],
              saleamount: tmpSaleamount,
              costamount: tmpCostamount,
              freightamount: tmpFreightamount,
              maolieamount: tmpSaleamount - tmpCostamount,
              maoliv,
              maolivstatus:2
          }
        )

      }
    }
    // console.log('orders---',orders)
    // console.log('orderForm.value---',orderForm.value)

    batchSaveOrderAccount(orders).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          closeDialog();
          emit("click");
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

const closeDialog = () => {
  isvisible.value = false;
  orderFormRef.value.resetFields();
  clearTimeout(timer);
};

const validateDecimal = (rule, value, callback) => {
  if (typeof value === 'undefined') { callback();}
  const reg = /^(\d+\.?)?\d{0,2}$/;
  if (!String(value).match(reg)) {
    callback(new Error("只能填写整数、小数须保留两位小数"));
  } else {
    callback();
  }
};

//表单验证规则
const rules = ref({
  saleamount: [
    // {
    //   required: true,
    //   message: "请输入销售金额",
    //   trigger: "blur",
    // },
    {
      //required: true,
      validator: validateDecimal,
      trigger: "blur",
    },
  ],
  costamount: [
    // {
    //   required: true,
    //   message: "请输入成本金额",
    //   trigger: "blur",
    // },
    {
      //required: true,
      validator: validateDecimal,
      trigger: "blur",
    },
  ],
  freightamount: [
    // {
    //   required: true,
    //   message: "请输入成本金额",
    //   trigger: "blur",
    // },
    {
      //required: true,
      validator: validateDecimal,
      trigger: "blur",
    },
  ],
});
</script>
  <style scoped>
.el-dialog {
  text-align: left;
}
.el-dialog__body {
  padding-top: 15px;
}
</style>